import moonPhaseMap from "./moonPhaseMap";
import { convertTo24Hour } from "./timeHelper";
import { getMappedCondition } from "./getMappedCondition";

/**
 * Wandelt die Rohdaten der API in dein internes Wetter-Format um
 */
  export function mapWeatherApiResponse(apiResponse) {
    if (!apiResponse || !apiResponse.current || !apiResponse.location) return null;

    return {
      city: apiResponse.location.name,
      time: apiResponse.location.localtime.split(" ")[1],
      localtimeFull: apiResponse.location.localtime, // 👈 z.B. "2025-03-30 14:00"
      weatherNow: {
        temperature: Math.round(apiResponse.current.temp_c),
        conditionRaw: apiResponse.current.condition.text,
        conditionMapped:
          getMappedCondition(apiResponse.current.condition.text.toLowerCase()) ||
          apiResponse.current.condition.text.toLowerCase(),
      },
      weatherDetails: {
        wind_kph: apiResponse.current.wind_kph,
        humidity: apiResponse.current.humidity,
        uv: apiResponse.current.uv,
        feelslike_c: Math.round(apiResponse.current.feelslike_c),
      },
    };
  }

/**
 * Wandelt die Forecastdaten der API in ein internes Format um
 * - Tag0: 5 Stunden ab nächster voller Stunde
 * - Tag0/1/2: zusätzlich 12:00 + 23:00
 */
export function mapForecastApiResponse(apiForecastResponse) {
    const forecastDays = apiForecastResponse?.forecast?.forecastday;
    if (!forecastDays || forecastDays.length < 3) return null;
  
    const localTimeString = apiForecastResponse.location.localtime; // z. B. "2025-03-29 02:44"
    const localHour = parseInt(localTimeString.split(" ")[1].split(":")[0]); // → 2
    const nextFullHour = localHour + 1;
  
    const hourlyToday = [];
    let hoursCollected = 0;
  
    for (let dayIndex = 0; dayIndex <= 1 && hoursCollected < 5; dayIndex++) {
      const day = forecastDays[dayIndex];
      const weekday = new Date(day.date).toLocaleDateString("en-US", {
        weekday: "long",
      });
  
      for (const hour of day.hour) {
        const hourHour = new Date(hour.time).getHours();
  
        if (
          (dayIndex === 0 && hourHour >= nextFullHour) ||
          (dayIndex === 1 && hoursCollected < 5)
        ) {
          hourlyToday.push({
            dateDay: weekday,
            hour: hour.time.split(" ")[1],
            weathericon: getMappedCondition(hour.condition.text.toLowerCase()),
            hourWeather: Math.round(hour.temp_c),
            hourRain: hour.chance_of_rain,
          });
          hoursCollected++;
        }
      }
    }

  // 🔁 Tagesdaten für 12:00 & 23:00 + Wochentag
  const extractDayData = (day) => {
    const wanted = ["12:00", "23:00"];
    const weekday = new Date(day.date).toLocaleDateString("en-US", {
      weekday: "long",
    });

    const times = wanted.map((targetTime) => {
      const match = day.hour.find((h) => h.time.endsWith(targetTime));
      return match
        ? {
            time: targetTime,
            temperature: Math.round(match.temp_c),
            condition: getMappedCondition(match.condition.text.toLowerCase()),
          }
        : null;
    }).filter(Boolean);

    return {
      dateDay: weekday,
      times,
    };
  };

  const day0 = extractDayData(forecastDays[0]);
  const day1 = extractDayData(forecastDays[1]);
  const day2 = extractDayData(forecastDays[2]);

  const today = forecastDays[0];

  return {
    sunrise: convertTo24Hour(today.astro.sunrise),
    sunset: convertTo24Hour(today.astro.sunset),
    moonPhaseName: today.astro.moon_phase,
    moonPhaseIcon: moonPhaseMap[today.astro.moon_phase] || moonPhaseMap.default,

    hourlyToday,
    day0,
    day1,
    day2,
  };
}

